
<div
    v-if  = "data"
    id    = "dms-viewer"
    style = "width: 100%; height: 100%; border-radius: 6px 0 6px 6px;"
>
    <div
        :class = "border ? 'lm-border pa-3' : null"
        style  = "width: 100%; height: 100%"
    >
        <div
            v-if  = "isPdf || isExcel"
            style = "width: 100%; height: 100%"
        >
            <iframe
                :src  = "data"
                style = "width: 100%; height: 100%; border: none;"
                :style="'border-radius:' + borderRadius + (topRight ? '; border-top-right-radius: 0;' : '')"
            >
            </iframe>
        </div>

        <p-dms-mail-viewer
            v-if   = "isMail"
            :mail  = "data"
            :popup = "popup"
            class  = "h-100"
        />

        <div
            v-if  = "isImage"
            style = "display: flex; width: 100%; height: 100%"
        >
            <img :src="data" alt="" style="margin: auto;max-width:100%;max-height:100%;border-style: solid;border-width: 1px;border-color: lightgrey;border-radius: 4px;">
        </div>
    </div>
</div>
